import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite, TimelineMax} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {RoadKill} from "../RoadKill";
import {RoadKillGameData, RoadKillInitData} from "../server/RoadKillData";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RKHelper} from "../utils/RKHelper";
import {RoadKillSound} from "../sound/RoadKillSound";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {JumpingWildAnimStates, JumpinWildSkins} from "../component/enums/RoadKillEnums";
import {JumpingWild} from "../component/JumpingWild";


export class RoadKillFreespinIntroView extends PIXI.Container implements StageLayer {
    private _button: ContinueButton;
    private _clickCallback: Function | null;
    private _isContinueBtnClick: boolean = false;
    private _introFSSpine: PIXI.spine.Spine;
    private _introSFSSpine: PIXI.spine.Spine;
    private _respinSpine: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "freeSpinIntroView";
        this.init();
    }

    public showIntro(callback: Function): void {
        const tl: TimelineMax = new TimelineMax(),
            data: RoadKillGameData | RoadKillInitData = RoadKill.model.gameData ? RoadKill.model.gameData : RoadKill.model.initData,
            animationName: string = RKHelper.getTransitionAnimName(data.mode, data.nextMode),
            isFSUpgrade: boolean = data.mode === RoadKillGameMode.FREESPIN && data.nextMode === RoadKillGameMode.SUPER_FREESPIN,
            isRespinUpgrade: boolean = data.mode === RoadKillGameMode.RESPIN && data.nextMode === RoadKillGameMode.FREESPIN,
            isFS: boolean = this.isFS(data.mode, data.nextMode),
            introSpine: PIXI.spine.Spine = (isFS || data.mode === RoadKillGameMode.RESPIN) ? this._introFSSpine : this._introSFSSpine;

        this._clickCallback = callback;

        if ((data.mode === RoadKillGameMode.NORMAL && data.nextMode === RoadKillGameMode.RESPIN) || data.mode === RoadKillGameMode.RESPIN && !isRespinUpgrade) {
            RoadKill.soundPlayer.fadeMusic(0, 400);
            if (!data.isRestoreState) {
                RoadKill.soundPlayer.playTrack(RoadKillSound.RESPIN_ONE_SHOT);
            }
            RoadKill.soundPlayer.playTrack(RoadKillSound.RESPIN_BG_MUSIC, 1, Number.MAX_VALUE);
            if (!data.isRestoreState) {
                tl.add(() => {
                    this._respinSpine.visible = true;
                    this._respinSpine.alpha = 1;
                });
                tl.add([RKHelper.playSpineWithTimeline(this._respinSpine, 0, "armsIn"), () => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.RESPIN_START);
                }]);
                tl.to(this, {duration: 0.8});
                tl.add(RKHelper.playSpineWithTimeline(this._respinSpine, 0, "armsOut"));
                tl.add(RoadKill.backgroundElements.transitionNormalToSFS(animationName), "<");
            }
            tl.add(() => {
                this._respinSpine.alpha = 0;
                this._respinSpine.visible = false;
                if (this._clickCallback) {
                    this._clickCallback();
                }
                this._clickCallback = null;
            })
            return;
        }

        if (!data.isRestoreState) {
            if (isFSUpgrade) {
                tl.add(() => {
                    this.onFSUpgrade(animationName);
                }, 0);

                for (let jwIdx: number = 0; jwIdx < 3; jwIdx++) {
                    const jw: JumpingWild = RoadKill.jumpingWildView.getWilds()[jwIdx];
                    if (!jw.upgraded) {
                        tl.add(RKHelper.playSpineWithTimeline(jw, 0, JumpingWildAnimStates.UPGRADE), 0);
                        tl.add(() => {
                            jw.autoUpdate = true;
                            jw.setSkin(JumpinWildSkins.UPGRADED);
                            jw.state.setAnimation(0, JumpingWildAnimStates.IDLE, true);
                            jw.animationState = JumpingWildAnimStates.IDLE;
                        }, ">")
                    }
                }
                tl.add(() => RoadKill.topAnimalController.onModeChange(data.nextMode)); //#208
                //return;
            } else if (isRespinUpgrade && !isFSUpgrade) {
                tl.add(this.onRespinUpgrade(animationName));
                return;
            } else if (RoadKill.model.gameData.wasFeatureBuy && RoadKill.model.gameData.mode === RoadKillGameMode.NORMAL && RoadKill.model.gameData.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
                //superFS transition moved to resultPres/
            } else {
                tl.addLabel("transitionStart");
                tl.add(RoadKill.backgroundElements.transitionNormalToSFS(animationName), "transitionStart");
            }
        }


        if (isFS) {
            tl.add(() => {
                introSpine.visible = true;
                RoadKill.soundPlayer.fadeMusic(0, 400);
                RoadKill.soundPlayer.playTrack(data.nextMode === RoadKillGameMode.FREESPIN ? RoadKillSound.FS_INTRO_LOOP : RoadKillSound.SFS_INTRO_LOOP, 1, Number.MAX_VALUE);
                if (!data.isRestoreState) {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.FS_INTRO_LOOP_START);
                }
            }, "transitionStart");
            tl.add(RKHelper.playSpineWithTimeline(introSpine, 0, "fsIntroIn"), "transitionStart");
        } else {
            tl.add(() => {
                introSpine.visible = true;
                RoadKill.soundPlayer.fadeMusic(0, 400);
                RoadKill.soundPlayer.playTrack(data.nextMode === RoadKillGameMode.FREESPIN ? RoadKillSound.FS_INTRO_LOOP : RoadKillSound.SFS_INTRO_LOOP, 1, Number.MAX_VALUE);
                if (!data.isRestoreState) {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.FS_INTRO_LOOP_START);
                }
            });
            tl.add(RKHelper.playSpineWithTimeline(introSpine, 0, isFS ? "fsIntroIn" : "sfsIntroIn"));
        }

        tl.add(this.showButton(1, 0, true));
        if (data.isRestoreState) {
            tl.progress(1);
        }
    }

    public onResize() {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    private isFS(mode: string, nextMode: string): boolean {
        let returnValue: boolean = false;
        if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.FREESPIN) {
            returnValue = true;
        }

        if (RoadKill.model.isRestore) {
            if (mode === RoadKillGameMode.FREESPIN && nextMode === RoadKillGameMode.FREESPIN) {
                returnValue = true;
            }
        }
        return returnValue;
    }

    private onFSUpgrade(animationName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            data: RoadKillGameData = RoadKill.model.gameData;
        tl.add([RoadKill.backgroundSpine.playTransitionAnim(animationName), () => {
            RoadKillUtils.fsTransition(0.75, true, RoadKill.jumpingWildView, true);
            RoadKillUtils.fsTransition(0.75, true, RoadKill.reelView);
            RoadKillUtils.fsTransition(0.75, true, RoadKill.winToggle);
            RoadKillUtils.fsTransition(0.75, true, RoadKill.backgroundElements);
            RoadKillUtils.fsTransition(0.75, true, RoadKill.topAnimalCounterView);
            RoadKillUtils.fsTransition(0.75, true, RoadKill.lifeView);
            RoadKill.soundPlayer.playTrack(RoadKillSound.MAIN_TO_SFS_TRASITION);
        }], "<");
        tl.add(() => {
            RoadKill.jumpingWildView.position.x = -3;
        })
        return tl;
    }

    private onRespinUpgrade(animationName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                RoadKill.soundPlayer.stopTrack(RoadKillSound.RESPIN_BG_MUSIC);
                RoadKill.backgroundSpine.changeBackground(RoadKill.model.gameData.nextMode);
                RoadKill.soundPlayer.switchMusic(RoadKillGameMode.FREESPIN);
                if (this._clickCallback) {
                    this._clickCallback();
                }
                this._clickCallback = null;
                this._introFSSpine.visible = false;
            }
        });
        tl.add(() => {
            this._introFSSpine.visible = true;
            this._introFSSpine.alpha = 1;
        })
        tl.add(RKHelper.playSpineWithTimeline(this._introFSSpine, 0, "fsIntroIn"));
        tl.to(this, {duration: 0.5});
        tl.add([RKHelper.playSpineWithTimeline(this._introFSSpine, 0, "fsIntroOut"), RoadKill.backgroundSpine.playTransitionAnim(animationName)]);
        return tl;
    }


    private init(): void {
        this._introFSSpine = this.createFSSpine();
        this._introSFSSpine = this.createSFSSpine();
        this._respinSpine = this.createRespinSpine();
        this._button = this.createButton();
        this.addChild(this._respinSpine, this._introFSSpine, this._introSFSSpine, this._button);
        this.onResize();
    }

    private createRespinSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("respin"));
        spine.visible = false;
        spine.position.set(360);
        spine.alpha = 0;
        spine.name = "respinSpine";
        return spine;
    }

    private createButton(): ContinueButton {
        const btn: ContinueButton = new ContinueButton();
        btn.addClickCallback(() => this.onButtonClick());
        btn.pivot.set(btn.width * 0.5, btn.height * 0.5);
        btn.enable(false);
        btn.visible = false;
        return btn;
    }

    private showButton(alpha: number = 1, durr: number = 0.5, enable: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._button.enable(enable);
            }
        });
        this._button.alpha = 0;
        this._button.visible = true;
        if (durr === 0) {
            tl.add(() => {
                this._button.alpha = 1;
            })
        } else {
            tl.to(this._button, {duration: durr, alpha: alpha});
        }
        return tl;
    }


    private onButtonClick(): void {
        const tl: TimelineMax = new TimelineMax({
                onComplete: () => {
                    introSpine.visible = false;
                    this._button.visible = false;
                }
            }),
            nextMode: string = RoadKill.model.nextMode,
            isRestoreState: boolean = RoadKill.model.isRestore,
            mode: string = RoadKill.model.mode,
            isFS: boolean = this.isFS(mode, nextMode),
            introSpine: PIXI.spine.Spine = isFS ? this._introFSSpine : this._introSFSSpine;
        this._isContinueBtnClick = true;
        this._button.enable(false);
        tl.add(() => {
            let passingMode: string = "";
            passingMode = isRestoreState ? (mode === RoadKillGameMode.NORMAL ? nextMode : mode) : nextMode;
            RoadKill.soundPlayer.switchMusic(passingMode);
            RoadKill.soundPlayer.fadeMusic(1, 400);
            RoadKill.soundPlayer.stopTrack(passingMode === RoadKillGameMode.FREESPIN ? RoadKillSound.FS_INTRO_LOOP : RoadKillSound.SFS_INTRO_LOOP);
            RoadKill.soundPlayer.playTrack(RoadKillSound.FS_SFS_CONTINUE_BUTTON);
        });
        tl.to(this._button, {
            duration: introSpine.skeleton.data.findAnimation(isFS ? "fsIntroOut" : "sfsIntroOut").duration,
            alpha: 0
        });
        tl.add(RKHelper.playSpineWithTimeline(introSpine, 0, isFS ? "fsIntroOut" : "sfsIntroOut"), "<");
        tl.add(RoadKill.keypadPlugin.show());
        tl.add(() => {
            RoadKill.keypadPlugin.hide();
            if (this._clickCallback) {
                this._clickCallback();
            }
            this._clickCallback = null;
        });
    }

    private createFSSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("fsIntro"));
        spine.position.set(355, 360);
        spine.visible = false;
        spine.name = "fsIntroSpine"
        return spine;
    }

    private createSFSSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("sfsIntro"));
        spine.position.set(355, 360);
        spine.visible = false;
        spine.name = "sfsIntroSpine"
        return spine;
    }
}